import React from 'react';
import { useTranslation } from 'react-i18next';

const flags = {
  it: "🇮🇹", fr: "🇫🇷", en: "🇬🇧", de: "🇩🇪", pt: "🇵🇹", es: "🇪🇸", ru: "🇷🇺"
};

const langPaths = {
  fr: "/fr/location-maison-appartement-sardaigne-san-teodoro",
  it: "/it/affitto-villa-appartamento-sardegna-san-teodoro",
  en: "/en/sardinia-villa-apartment-rental-san-teodoro",
  de: "/de/ferienhaus-sardinien-san-teodoro",
  pt: "/pt/aluguel-villa-sardenha-san-teodoro",
  es: "/es/alquiler-villa-sardinia-san-teodoro",
  ru: "/ru/arenda-villy-sardinija-san-teodoro"
};

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleLangChange = (e, lang) => {
    e.preventDefault(); // empêche le reload
    i18n.changeLanguage(lang); // change la langue dans i18next
    window.history.pushState({}, '', langPaths[lang]); // modifie l’URL visible
  };

  return (
    <div className="langSwitch" style={{ textAlign: 'center', padding: '10px', backgroundColor :'slategray'}}>
      {Object.entries(flags).map(([lang, flag]) => (
        <a
          key={lang}
          href={langPaths[lang]}
          onClick={(e) => handleLangChange(e, lang)}
          style={{
            cursor: 'pointer',
            fontSize: '1.5rem',
            margin: '0 6px',
            opacity: i18n.language === lang ? 1 : 0.6,
            textDecoration: 'none'
          }}
        >
          {flag}
        </a>
      ))}
      {/* Bouton "Others" */}
      <a
        href="/help"
        className='autreLang'
        title="Autres langues"
      >
        🌍 Others
      </a>
    </div>
  );
};

export default LanguageSwitcher;
